import { ReactNode } from 'react';

import { AlertProps as MuiAlertProps } from '@mui/material';
import { AlertStyled } from 'shared/mui/Alert/Alert.styled';
import { AlertTitle } from 'shared/mui/Alert/AlertTitle/AlertTitle';

export type AlertProps = { title?: ReactNode } & MuiAlertProps;

export const Alert: React.FC<AlertProps> = ({ title, children, ...props }) => {
  return (
    <AlertStyled {...props}>
      {title && <AlertTitle>{title}</AlertTitle>}
      {children}
    </AlertStyled>
  );
};
